import { Container, Logo, NavigationMenu, NavigationMenuItem, NavigationMenuList, NavigationMenuTrigger } from "@/shared/components";
import { Link } from "react-router";
import { ThemeToggleDropdown } from "./navbar";

export function MobileNavbar() {
    return (
        <header className="bg-elevated-1 relative border-b">
            <Container fluid>
                <div className="flex h-(--header-height) items-center justify-between">
                    <div className="flex flex-row items-center justify-between gap-14">
                        <Link to="/" className="flex flex-row items-center justify-between gap-3 text-xl font-bold">
                            <Logo />
                            <h5 className="text-m text-content-emphasis leading-m font-bold">SEIN</h5>
                        </Link>

                        <NavigationMenu>
                            <NavigationMenuList className="gap-m flex h-(--header-height) flex-row">
                                <NavigationMenuItem className="h-full">
                                    <NavigationMenuTrigger className="relative flex h-full flex-col items-center" selected>
                                        <span className="m-auto">Vos Registratie</span>
                                    </NavigationMenuTrigger>
                                </NavigationMenuItem>
                            </NavigationMenuList>
                        </NavigationMenu>
                    </div>

                    <div className="flex items-center gap-4">
                        <ThemeToggleDropdown />
                    </div>
                </div>
            </Container>
        </header>
    );
}
